var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-tree',{attrs:{"value":_vm.checkKeysList},on:{"change":v => (_vm.checkKeysList = v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }